import React, {useEffect, useState} from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, styled} from "@mui/material";
import {DateRangePicker} from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {convertDateToString} from "../utils/cert-helper";
import SearchIcon from '@mui/icons-material/Search';
import {getQueryString} from "../utils/http-helpers";
import RefreshIcon from '@mui/icons-material/Refresh';
import {customRangeLabels} from "../utils/customStyles";

const StyledDialog = styled(Dialog)({
    '& .MuiDialog-paper': {
        maxWidth: '1000px',
    }
})
const StyledDiv = styled('div')({
    display: 'flex',
    gap: 10,
})

export default function PublishedSearchPanel(props) {

    const onQueryStringChanged = props.onQueryStringChanged;
    const onRefresh = props.onRefresh;
    const setPage = props.setPage;

    const [params, setParams] = useState({});
    const [queryString, setQueryString] = useState("");
    const [dialogOpen, setDialogOpen] = useState(false);

    const [dateRange, setDateRange] = useState({
        startDate: "",
        endDate: "",
    });
    const [state, setState] = useState([
        {
            startDate: null,
            endDate: new Date(""),
            key: 'selection'
        }
    ]);

    useEffect(() => {
        console.log("useEffect, query String updated: ", queryString);
        onQueryStringChanged(queryString);
    }, [queryString])

    const handleDateChange = (date) => {
        const newParams = {...params};
        setState([date.selection]);
        setDateRange({
            startDate: convertDateToString(date.selection.startDate),
            endDate: convertDateToString(date.selection.endDate),
        })

        if (date === "") {
            if (params.startDate !== undefined || params.endDate !== undefined) {
                delete params.startDate;
                delete params.endDate;
            }
        } else {
            newParams.startDate = convertDateToString(date.selection.startDate);
            newParams.endDate = convertDateToString(date.selection.endDate);
        }
        setParams(newParams);
    }

    const handleSearch = () => {
        setPage(0);
        const s = getQueryString(params);
        console.log("search ", params, s);
        setQueryString(s);
    }

    const handleDateRangePickerReset = () => {
        const newParam = {...params}
        setDateRange({
            startDate: "",
            endDate: "",
        })
        setState([
            {
                startDate: null,
                endDate: new Date(""),
                key: 'selection'
            }
        ])
        delete newParam.startDate;
        delete newParam.endDate;

        setParams(newParam);
    }

    const handleResetClick = () => {
        setPage(0);
        setParams({});
        setQueryString(getQueryString({}));
        setDateRange({startDate: "", endDate: ""});
    }

    const handleRefresh = () => {
        onRefresh(new Date().getTime());
    }

    return (
        <StyledDiv>
            <StyledDialog
                open={dialogOpen}
            >
                <DialogTitle>{"Please select a date range"}</DialogTitle>
                <DialogContent>
                    <DateRangePicker
                        onChange={date => handleDateChange(date)}
                        showSelectionPreview={true}
                        moveRangeOnFirstSelection={false}
                        months={2}
                        ranges={state}
                        staticRanges={customRangeLabels}
                        direction="horizontal"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDateRangePickerReset} variant='outlined'>RESET</Button>
                    <Button onClick={() => setDialogOpen(false)} variant='contained'>Confirm</Button>
                </DialogActions>
            </StyledDialog>
            <Button
                onClick={() => setDialogOpen(true)}
                variant="text"
                endIcon={<KeyboardArrowDownIcon/>}
            >
                {dateRange.startDate !== "" ? `${dateRange.startDate} - ${dateRange.endDate}` : "Select a date range"}
            </Button>

            <Button variant='contained' onClick={handleSearch} startIcon={<SearchIcon/>}>
                Search
            </Button>
            <Button variant='outlined' onClick={handleRefresh} startIcon={<RefreshIcon />}>
                Refresh
            </Button>
            <Button variant='outlined' onClick={handleResetClick}>
                Reset
            </Button>
        </StyledDiv>
    )
}